import React, { useEffect, useState } from "react";
import { Button, Container, Modal } from "react-bootstrap";
import {useInView} from 'react-intersection-observer'


/**
 * VollmachtModal
 * 
 * shows customer "Vollmacht Mandat"
 * 
 * @param {show, setShow} props - show= displays modal, setShow= hides it
 * @returns None
 */
const VollmachtModal = (props) => {

    const [btnDisabled, setBtnDisabled] = useState(true); // Button before scroll is disabled
    const [ref, InView] = useInView({
        triggerOnce: true,
        rootMargin: "0px 0px",
    });

    const ReadBtnHandler = () => {
        props.hasReadVollmacht(true);
        props.setData(prev => ({...prev, 
            partner: ({...prev.partner, x_file_vollmacht_readed: true})
        }));
        props.setShow(false);
    }

    useEffect(() => {
        if (InView) setBtnDisabled(false);
    }, [InView])


    // View
    return (
        <Modal fullscreen size="lg" show={props.show}>
            <Modal.Header closeButton onHide={() => props.setShow(false)}>
                <Modal.Title>Vollmacht</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
			        <div dangerouslySetInnerHTML={{__html: props.vollmachtText}}></div>
                    <div ref={ref} ></div>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Button className="btn-energo" disabled={btnDisabled} onClick={() => ReadBtnHandler()}>Gelesen</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default VollmachtModal;